<template>
  <div class="row row-height">
    <FullscreenLoader v-if="loader" />

    <v-sheet
      v-else-if="!loader && !isChildren"
      class="overflow-hidden col-md-12"
      style="position: relative; border-radius: 10px"
    >
      <div>
        <v-row align="center" justify="center">
          <div
            :class="
              overlay
                ? 'hideOnMoblie background-opacity col-md-9'
                : 'col-md-12 navigationWidth no-padding '
            "
          >
            <v-row class="blue-underline mb-1">
              <v-col class="col-xl-2 col-md-2 cols-4 pt-2 pb-0" cols="12">
                <div class="col-md-12">
                  <h3 class="form-title font col-md-12 font-18">Providers</h3>
                </div>
              </v-col>
              <v-col class="col-xl-3 col-md-5 cols-3" cols="12">
                <div
                  class="col-md-12 d-flex mt-4 no-padding"
                  style="width: 80%"
                >
                  <v-text-field
                    :disabled="overlay"
                    class="input-control mr-5"
                    prepend-inner-icon="mdi-magnify"
                    @input="searchProviders"
                    light
                    dense
                    outlined
                    placeholder="Search Providers"
                  ></v-text-field>
                  <v-btn
                    :disabled="overlay"
                    class="text-gray filter-btn"
                    @click.stop="showFilterSideBar"
                  >
                    <svg
                      width="17"
                      class="mr-2"
                      height="14"
                      viewBox="0 0 17 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 1H16"
                        stroke="#424242"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M2.59766 5H14.403"
                        stroke="#424242"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M6.3125 13H10.6858"
                        stroke="#424242"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M4.19531 9H12.8046"
                        stroke="#424242"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Filters
                  </v-btn>
                </div>
              </v-col>
              <v-col
                class="col-md-5 col-xl-7 text-end pr-4 pt-6"
                cols="12"
                align="end"
              >
                <v-btn
                  class="my-1 mr-4 gray-border-buttons"
                  @click="exportData('providers')"
                >
                  <svg
                    class="mr-2"
                    width="15"
                    height="16"
                    viewBox="0 0 15 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.2361 10.7639C14.0329 10.7639 13.838 10.8434 13.6937 10.985C13.5495 11.1267 13.4676 11.319 13.4659 11.5202V12.6764C13.4659 12.9367 13.3615 13.1862 13.1756 13.3703C12.9897 13.5543 12.7376 13.6577 12.4747 13.6577H2.52525C2.26238 13.6577 2.01027 13.5543 1.8244 13.3703C1.63852 13.1862 1.53409 12.9367 1.53409 12.6764V11.5202C1.51671 11.3307 1.42838 11.1544 1.28645 11.0261C1.14452 10.8978 0.959257 10.8266 0.767046 10.8266C0.574834 10.8266 0.389569 10.8978 0.247642 11.0261C0.105715 11.1544 0.0173841 11.3307 0 11.5202V12.6764C0 13.3395 0.266053 13.9753 0.739629 14.4442C1.21321 14.913 1.85551 15.1764 2.52525 15.1764H12.4747C13.1445 15.1764 13.7868 14.913 14.2604 14.4442C14.7339 13.9753 15 13.3395 15 12.6764V11.5202C15 11.3196 14.9195 11.1272 14.7763 10.9854C14.633 10.8436 14.4387 10.7639 14.2361 10.7639Z"
                      fill="#707070"
                    />
                    <path
                      d="M7.49971 0.176392C7.17488 0.176392 6.86336 0.304137 6.63368 0.531525C6.404 0.758913 6.27496 1.06732 6.27496 1.38889V7.05139C6.27496 7.09283 6.25833 7.13257 6.22873 7.16188C6.19913 7.19118 6.15899 7.20764 6.11713 7.20764H4.43784C4.32437 7.21533 4.2151 7.25322 4.12158 7.31731C4.02807 7.3814 3.95378 7.46931 3.90657 7.57175C3.85935 7.6742 3.84097 7.78736 3.85337 7.89929C3.86576 8.01122 3.90847 8.11776 3.97698 8.20764L7.03885 11.6951C7.0979 11.7576 7.16927 11.8074 7.24855 11.8414C7.32782 11.8754 7.4133 11.893 7.49971 11.893C7.58611 11.893 7.6716 11.8754 7.75087 11.8414C7.83014 11.8074 7.90151 11.7576 7.96057 11.6951L11.0224 8.20764C11.0909 8.11776 11.1337 8.01122 11.146 7.89929C11.1584 7.78736 11.1401 7.6742 11.0928 7.57175C11.0456 7.46931 10.9713 7.3814 10.8778 7.31731C10.7843 7.25322 10.675 7.21533 10.5616 7.20764H8.88228C8.84042 7.20764 8.80028 7.19118 8.77068 7.16188C8.74108 7.13257 8.72445 7.09283 8.72445 7.05139V1.38889C8.72445 1.06732 8.59542 0.758913 8.36573 0.531525C8.13605 0.304137 7.82453 0.176392 7.49971 0.176392V0.176392Z"
                      fill="#707070"
                    />
                  </svg>

                  Export</v-btn
                >
                <v-btn
                  class="my-1 mr-2 gray-border-buttons"
                  @click="
                    $router.push('/dpc-providers/providers/add-new')
                  "
                >
                  <svg
                    class="mr-2"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 7.5H15"
                      stroke="#707070"
                      stroke-width="2"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7.5 0V15"
                      stroke="#707070"
                      stroke-width="2"
                      stroke-linejoin="round"
                    />
                  </svg>

                  New</v-btn
                >
              </v-col>
            </v-row>
           
            <div v-if="loader">
              <v-progress-linear
              class="text-center justify-center mt-0 "
              color="primary"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </div>
          <v-row class="col-md-12" v-if="allProviders.length < 1">
            <v-col md="12">
              No providers to show
              <a 
               @click=" $router.push('/dpc-providers/providers/add-new')">- Click Here to Add a Provider.</a>
            </v-col>
          </v-row>
            <v-data-table v-else
                  :headers="tableHeaders" 
                  :items="allProviders"
                  :search="searchValue"
                  :hide-default-header="false"
                  :mobile-breakpoint="0"
                  class="elevation-1 pa-2"
                >
                  <template v-slot:body="{ items }" >
                    <tr v-for="item in items" :key="item.id" class="pa-1">
                     <td class="pa-1 font-14">
                              <a @click="singleProvider(item)">
                                 {{ item.providerName }}
                              </a>
                            </td>
                            <td class="pa-1 text-gray font-14">
                              <span v-if="item.gender == 'F'">Female</span>
                           <span v-else-if="item.gender == 'M'">Male</span>
                            </td>
                            <td class="pa-1 text-gray font-14">
                              {{ item.specialty }}
                            </td>
                            <td class="pa-1 text-gray font-14">
                              <span v-if="item && item.locations && item.locations.length > 0">
                                <span v-for="(loc,index) in item.locations" :key="index">
                                  {{loc.name}}<span v-if="index < item.locations.length - 1 ">,</span>
        
                                </span>
                              </span>
                              <span v-else>/</span>                           
                             </td>
                         
                            <td class="text-end pa-1 pr-4 font-14">
                              <svg
                        class="pointer mt-2"
                        @click="singleProvider(item)"
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.9955 19.5396L6.87109 20.1296L7.45998 16.004L15.8611 7.6029C16.3299 7.13406 16.9658 6.87067 17.6289 6.87067C18.2919 6.87067 18.9278 7.13406 19.3966 7.6029C19.8655 8.07175 20.1289 8.70764 20.1289 9.37068C20.1289 10.0337 19.8655 10.6696 19.3966 11.1385L10.9955 19.5396Z"
                          stroke="#4072B7"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M1 13.5C1 16.8152 2.31696 19.9946 4.66117 22.3388C7.00537 24.683 10.1848 26 13.5 26C16.8152 26 19.9946 24.683 22.3388 22.3388C24.683 19.9946 26 16.8152 26 13.5C26 10.1848 24.683 7.00537 22.3388 4.66117C19.9946 2.31696 16.8152 1 13.5 1C10.1848 1 7.00537 2.31696 4.66117 4.66117C2.31696 7.00537 1 10.1848 1 13.5V13.5Z"
                          stroke="#4072B7"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <svg
                        class="ml-2 mt-2 pointer"
                        @click="removeItem(item)"
                        width="28"
                        height="26"
                        viewBox="0 0 28 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.35547 13C1.35547 16.1826 2.65524 19.2348 4.96884 21.4853C7.28244 23.7357 10.4204 25 13.6923 25C16.9642 25 20.1021 23.7357 22.4157 21.4853C24.7293 19.2348 26.0291 16.1826 26.0291 13C26.0291 9.8174 24.7293 6.76516 22.4157 4.51472C20.1021 2.26428 16.9642 1 13.6923 1C10.4204 1 7.28244 2.26428 4.96884 4.51472C2.65524 6.76516 1.35547 9.8174 1.35547 13V13Z"
                          stroke="#D00000"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8.75781 17.8002L18.6273 8.2002"
                          stroke="#D00000"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18.6273 17.8002L8.75781 8.2002"
                          stroke="#D00000"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                            </td>
                    </tr>
                  </template>
                </v-data-table>
           
            <v-row class="justify-end mt-3 mb-2" v-if="selectAll">
              <v-btn class="blue-buttons" @click="removeSelected()"
                >Remove Selected</v-btn
              >
            </v-row>
            <v-row
              :class="!overlay ? 'justify-end mt-3' : 'disabled-table'"
              v-if="!noDataMessage && showSaveButton"
            >
              <v-btn class="blue-buttons" @click="addProviders()"
                >Save & Apply</v-btn
              >
            </v-row>

            <table  id="providers"  style="display: none">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Gender</th>
                  <th>Specialty</th>
                  <th>Location(s)</th>
                </tr>
              </thead>
              <tbody v-if="allProviders.length > 0">
                <tr
                  v-for="(item, index) in allProviders"
                  :key="index"
                  :id="'id' + index"
                >
                  <td v-if="item.companyName">
                    <a style="text-decoration: underline;" @click="singleProvider(item)">{{ item.companyName }}</a>
                  </td>
                  <td v-else-if="item.providerName">
                    <a style="text-decoration: underline;"  @click="singleProvider(item)">{{ item.providerName }}</a>
                  </td>
                  <td style="text-decoration: underline;"  v-else><a @click="singleProvider(item)">/</a></td>
                  <td class="text-gray">
                    <!-- <span v-html=" item.sex ? item.sex.charAt(0).toUpperCase() + item.sex.slice(1) : '/' "></span> -->
                    {{ item.gender ? item?.gender == 'M' ? 'Male': 'Female' : '/' }}
                  </td>
                  <td v-if="item.taxonomy || item.specialty" class="text-gray">
                    {{ item.taxonomy ? item.taxonomy : item.specialty ? item.specialty : '/' }}
                  </td>
                  <td class="text-gray">
                    <span v-if="item && item.locations && item.locations.length > 0">
                      <span v-for="(loc,index) in item.locations" :key="index">
                        {{loc.name}}<span v-if="index < item.locations.length - 1 ">,</span>
                      </span>
                    </span>
                    <span v-else>/</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-row>
      </div>

      <v-navigation-drawer
        class="userFilterPosition"
        width="350"
        v-model.trim="drawer"
        absolute
        temporary
      >
        <div class="filter-sideBar">
          <div>
            <div class="row no-padding col-md-12 justify-space-between">
              <h3 class="font pl-3 mt-1">Providers Filters</h3>
              <h1 class="pointer mr-3" @click.stop="drawer = !drawer">x</h1>
            </div>
            <v-divider></v-divider>
            <div class="col-md-12">
              <div
                class="row col-md-12 justify-space-between no-padding no-margin"
              >
                <div class="no-padding font filter-items-font font-weight-bold">
                  Selected Filter
                </div>
                <div
                  class="underline-text pointer text-gray filter-items-font"
                  @click="clearAll"
                >
                  Clear All
                </div>
              </div>
            </div>
            <div class="overflow-fitlers-buttons">
              <div class="row mb-1 col-md-12">
                <v-btn
                  v-for="(item, index) in selectedArray.concat(
                    selectedLocationArray,
                    selectedSpecialtyArray
                  )"
                  :key="index"
                  class="text-center mb-1 ml-2 mr-2 filter-btn"
                  small
                >
                  <span v-html="item.text"></span>
                  <h5 class="ml-3" @click="removeFilter(item)">x</h5>
                </v-btn>
              </div>
              <v-divider></v-divider>
              <v-expansion-panels
                accordion
                multiple
                v-model.trim="panel"
                class="no-shadow no-padding user-expansion-panels"
              >
                <v-expansion-panel class="no-shadow no-padding">
                  <v-expansion-panel-header
                    class="
                      font-weight-black
                      change-padding-filter
                      filter-items-font
                    "
                    >Provider Type</v-expansion-panel-header
                  >
                  <v-expansion-panel-content class="no-padding content-filter">
                    <v-text-field
                      solo
                      class="filter-serach-input mb-4"
                      v-model.trim="type"
                      @input="searchStatus()"
                      dense
                      :hide-details="true"
                      placeholder="Search"
                      append-icon="fa fa-search"
                    ></v-text-field>
                    <v-checkbox
                      label="MD"
                      color="primary"
                      v-if="showType.md"
                      v-model.trim="filter.type.md"
                      class="no-padding small-text radio-buttons-filters"
                      hide-details
                      :on-icon="'mdi-square'"
                      @click="
                        pushFilter(
                          { text: 'MD', value: 'md' },
                          filter.type.md
                        )
                      "
                    >
                    </v-checkbox>
                    <v-checkbox
                      label="DO"
                      color="primary"
                      v-if="showType.do"
                      v-model.trim="filter.type.do"
                      class="no-padding radio-buttons-filters"
                      hide-details
                      :on-icon="'mdi-square'"
                      @click="
                        pushFilter(
                          { text: 'DO', value: 'do' },
                          filter.type.do
                        )
                      "
                    >
                    </v-checkbox>
                    <v-checkbox
                      label="ARNP"
                      color="primary"
                      v-if="showType.arnp"
                      :on-icon="'mdi-square'"
                      v-model.trim="filter.type.arnp"
                      class="no-padding radio-buttons-filters"
                      hide-details
                      @click="
                        pushFilter(
                          { text: 'ARNP', value: 'arnp' },
                          filter.type.arnp
                        )
                      "
                    >
                    </v-checkbox>
                    <v-checkbox
                      label="PA"
                      color="primary"
                      v-if="showType.pa"
                      v-model.trim="filter.type.pa"
                      :on-icon="'mdi-square'"
                      class="no-padding radio-buttons-filters"
                      hide-details
                      @click="
                        pushFilter(
                          { text: 'PA', value: 'pa' },
                          filter.type.pa
                        )
                      "
                    >
                    </v-checkbox>

                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="no-shadow no-padding">
                  <v-expansion-panel-header
                    class="
                      font-weight-black
                      change-padding-filter
                      filter-items-font
                      mb-0
                      pb-0
                    "
                    >Specialties</v-expansion-panel-header
                  >
                 <v-expansion-panel-content class="no-padding content-filter">
                    <v-text-field
                      solo
                      class="filter-serach-input no-padding mb-4"
                      v-model.trim="specialty"
                      dense
                      :hide-details="true"
                      @input="searchSpecialty()"
                      placeholder="Search"
                      append-icon="fa fa-search"
                    ></v-text-field>
                    <v-checkbox
                      label="All"
                      color="primary"
                      v-if="showSpecialties['all']"
                      :on-icon="'mdi-square'"
                      v-model.trim="filter.specialty['all']"
                      class="no-padding radio-buttons-filters"
                      hide-details
                      @click="
                        pushtoSpecialtyFilter(
                          { text: 'All', value: 'allSpecialties' },
                          filter.specialty['all']
                        )
                      "
                    >
                    </v-checkbox>
                    <v-checkbox v-for="(item,index) in specialties" :key="index"
                      :label="item"
                      color="primary"
                      v-if="showSpecialties[item]"
                      v-model.trim="filter.specialty[item?.toLowerCase()]"
                      :on-icon="'mdi-square'"
                      class="no-padding radio-buttons-filters"
                      hide-details
                      @click="
                        pushtoSpecialtyFilter(
                          { text: item, value:item?.toLowerCase() },
                          filter.specialty[item?.toLowerCase()]
                        )
                      "
                    >
                    </v-checkbox>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="no-shadow no-padding">
                  <v-expansion-panel-header
                    class="
                      font-weight-black
                      change-padding-filter
                      filter-items-font
                      mb-0
                      pb-0
                    "
                    >Locations</v-expansion-panel-header
                  >
                 <v-expansion-panel-content class="no-padding content-filter">
                    <v-text-field
                      solo
                      class="filter-serach-input no-padding mb-4"
                      v-model.trim="location"
                      dense
                      :hide-details="true"
                      @input="searchLocation()"
                      placeholder="Search"
                      append-icon="fa fa-search"
                    ></v-text-field>
                    <v-checkbox
                      label="All"
                      color="primary"
                      v-if="showLocation['all']"
                      :on-icon="'mdi-square'"
                      v-model.trim="filter.location['all']"
                      class="no-padding radio-buttons-filters"
                      hide-details
                      @click="
                        pushtoLocationFilter(
                          { text: 'All', value: 'allLocations' },
                          filter.location['all']
                        )
                      "
                    >
                    </v-checkbox>
                    <v-checkbox v-for="(item,index) in locations" :key="index"
                      :label=item.name
                      color="primary"
                      v-if="showLocation[item.name]"
                      v-model.trim="filter.location[item.name?.toLowerCase()]"
                      :on-icon="'mdi-square'"
                      class="no-padding radio-buttons-filters"
                      hide-details
                      @click="
                        pushtoLocationFilter(
                          { text: item.name, value:item.name?.toLowerCase() },
                          filter.location[item.name?.toLowerCase()]
                        )
                      "
                    >
                    </v-checkbox>

                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>
          <div>
            <v-divider></v-divider>
            <v-btn
              class="blue-buttons col-md-12 mt-3 mb-md-3 mb-xl-0"
              @click="filterProviders"
              >View Result</v-btn
            >
          </div>
        </div>
      </v-navigation-drawer>
    </v-sheet>
    <v-dialog v-model.trim="dialog" max-width="600px" persistent>
      <v-card>
        <v-col>
          <h3>Remove Provider</h3>
        </v-col>

        <v-col>
          <span>Are you sure you want to delete this Provider? </span>
        </v-col>

        <v-col>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="blue-buttons float-class" @click="confirmRemove"
              >Confirm</v-btn
            >

            <v-btn class="button-style float-class" @click="closePopUp"
              >Close</v-btn
            >
          </v-card-actions>
        </v-col>
      </v-card>
    </v-dialog>
    <router-view></router-view>
    <successModal
      ref="success_modal"
      v-on:confirm="closeSuccessModal"
    ></successModal>
    <errorModal
    ref="error_modal"
     v-on:confirm="closeErrorModal">
    </errorModal>

  </div>
</template>
<script>
import api from "../../../../../services/api";
import successModal from "../../../../TablesTemplate/SuccessDialog.vue";
import errorModal from "../../../../TablesTemplate/ErrorDialog.vue";
import { mapGetters } from "vuex";
import FullscreenLoader from "../../../../Common/FullscreenLoader.vue";
export default {
  components: { successModal, errorModal, FullscreenLoader },
  data() {
    return {
      searchValue: '',
      pagination: {
      rowsPerPage: 30
    },
      tableHeaders: [
        {text: 'NAME ', value:'name', align: 'start', sortable: true},
        {text: 'GENDER', value:'gender', align: 'start'},
        {text: 'SEPCIALTY', value:'specialty', align: 'start'},
        {text: 'LOCATION(S)', value:'locations', align: 'start'},
        {text: 'ACTIONS', align: 'start'},
      ],
specialties:[],
      locations:[],
      ratingValue: 2,
      items: [],
      manualOverrideProviders: [
        {
          text: "Manual Override",
          value: true,
        },
      ],
      filterItems: false,
      prefferedProviderItems: [
        {
          text: "Preferred Provider",
          value: true,
        },
      ],
      showSaveButton: false,
      filterMatchingStatus: [
        {
          text: "Matched",
          value: "matched",
        },
        {
          text: "Not Matched",
          value: "notMatched",
        },
      ],
      noDataMessage: "",
      providerType: [
        {
          text: "Hospital",
          value: "hospital",
        },
        {
          text: "Doctor Office",
          value: "doctorOffice",
        },
        {
          text: "Imagining",
          value: "imaging",
        },
        {
          text: "Laboratory",
          value: "laboratory",
        },
        {
          text: "Other",
          value: "other",
        },
      ],

      allProviders: [ ],
      display: true,
      overlay: false,
      windowWidth: window.innerWidth,
      dialog: false,
      filterArray: [],
      itemToRemove: null,
      itemById: {},
      index: 0,
      selectAll: false,
      selectedRows: [],
      loader: false,
      drawer: null,
      showStatus: {
        all: true,
        active: true,
        "in active": true,
        invited: true,
        "join request": true,
      },
      showType: {
        md: true,
        do: true,
        arnp: true,
        pa: true,

      },
      showLocation:{},
      showSpecialties:{},

      userStatus: [
        {
          text: "ALL",
          value: "all",
        },

        {
          text: "Join Request",
          value: "join",
        },
        {
          text: "Active",
          value: "active",
        },
        {
          text: "In Active",
          value: "inactive",
        },
        {
          text: "Invited",
          value: "invited",
        },
      ],
      userType: [
        {
          text: "ALL",
          value: "all",
        },
        {
          text: "Admins",
          value: "admins",
        },
        {
          text: "General User",
          value: "users",
        },
      ],
      selectedArray: [],
      rows: [1],
      selectedTypeArray: [],
      selectedLocationArray: [],
      selectedSpecialtyArray: [],

      getUsers: [],
      panel: [0, 1, 2],
      filterUse: false,
      type: "",
      location:"",
      specialty:"",

      status: "",
      statusArray: [],
      noDataForThisLocationMessage: "",
      typeArray: [],
      filter: {
        status: {
          all: false,
          active: false,
          inactive: false,
          invited: false,
          join: false,
        },
        type: {
          all: false,
          user: false,
          admin: false,
        },
        location:{},
        specialty:{}

      },
    };
  },
  created() {
    
    this.getLocations();
    if (this.windowWidth < 600) {
      this.display = false;
    } else {
      this.display = true;
    }
    this.overlay = false;
    this.filterArray = this.allProviders;
  if (this.getFilterBy) {
      this.this.getAllUsers();
    } else {
      this.getAllUsers("all");
    }

  },
  computed: {
    ...mapGetters(["showRoutePathForFilter", "getLocationId"]),
    path() {
      return this.$route.path;
    },
    getClient() {
      return this.$store.getters.getClientGetter;
    },
    routeParams() {
      return this.$route.params.name;
    },

    isChildren() {
      let bool = false;
      if (this.$route.meta && this.$route.meta.isChildren) {
        bool = true;
      }

      return bool;
    },
    overlayClass() {
      let str = "";
      if (this.display) {
        str = "col-md-12";
        if (document.getElementById("hideOnMobile")) {
          document.getElementById("hideOnMobile").style.display =
            "none !important";
        }
      } else if (this.overlay) {
        str = "col-md-9 disabled-table";
      } else if (!this.display) {
        str = "col-md-12";
      } else {
        str = "col-md-12";
      }
      return str;
    },
    filteredProviders() {
 return this.allProviders.filter(item => {
   let search = this.searchValue.toLowerCase()
   let match = false
   if(item.providerName)match = match || item.providerName.toLowerCase().includes(search)
   if(item.specialty)match = match || item.specialty.toLowerCase().includes(search)
   return match
 })
},
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  watch: {
    '$route': {
        handler: function() {
      this.getAllProviders();
        },
        deep: true,
        immediate: true
    },
    showRoutePathForFilter: {
      handler(newValue, oldValue) {
        this.drawer = this.showRoutePathForFilter;
      },
      deep: true,
    },
    drawer: {
      handler(newValue, oldValue) {
        this.$store.commit("setNavItemFilter", this.drawer);
      },
      deep: true,
    },

    getLocationId: {
      handler(newValue, oldValue) {
        this.getAllProviders();
        // this.getAllUsers();
      },

      deep: true,
    },
  },

  methods: {
    closeErrorModal() {
      this.$refs.error_modal.closePopUp();
    },
    filterProviders() {
      api()
        .get("/dpcproviders/providers")
        .then((res) => {
          this.allProviders = res.data;
          this.filterArray = res.data;
            let params = "";
            let type = "";
            let location = [];
            let specialty = [];

            for (let key in this.filter.location) {
              if (this.filter.location[key]) {
                location.push(key) ;
              }
            }
             if (location.length !== 0 ){
              this.allProviders = this.filterArray.filter(function (el) {
                  return el.locations.some(e =>location.includes(e.name?.toLowerCase())) 
              });
              this.filterArray = this.allProviders
            }
            for (let key in this.filter.specialty) {
              if (this.filter.specialty[key]) {
                specialty.push(key) ;
              }
            }
          if ( specialty.length !== 0){
              this.allProviders = this.filterArray.filter(function (el) {
                  return specialty.includes(el.specialty?.toLowerCase())
              });
            }

          if (this.allProviders.length < 1) {
            this.filterItems = true;
          } else {
            this.filterItems = false;
          }
          this.drawer = false;
        });
    },
    exportData(tableID, filename = "") {
      var elt = document.getElementById(tableID);
      var downloadLink;
      var dataType = "application/vnd.ms-excel";
      var tableSelect = elt;
      var tableHTML = tableSelect.outerHTML.replace(/ /g, "%20");

      // Specify file name
      filename = filename ? filename + ".xls" : "excel_data.xls";

      // Create download link element
      downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        var blob = new Blob(["\ufeff", tableHTML], {
          type: dataType,
        });
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = "data:" + dataType + ", " + tableHTML;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }
    },
    showFilterSideBar() {
      this.drawer = !this.drawer;
      if (this.drawer) {
        this.$store.commit("setNavItemFilter", this.drawer);
      } else {
        this.$store.commit("setNavItemFilter", false);
      }
    },
    pushtoTypeFilter(item, checked) {
      if (checked) {
        if (item.value == "allLocations") {
          this.selectedTypeArray = [];
          this.filter.type = {
            md: true,
            do: true,
            arnp: true,
            pa: true,
          };
          this.selectedTypeArray.push({ text: "All", value: "allLocations" });
        } else {
          this.selectedTypeArray.push(item);
        }
      } else {
        if (item.value == "allLocations" || this.filter.type.all) {
          this.filter.type = {
            md: false,
            do: false,
            arnp: false,
            pa: false,
          };
          this.selectedTypeArray = [];
        } else {
          this.selectedTypeArray.forEach((el, index) => {
            if (el.value == item.value) {
              this.selectedTypeArray.splice(index, 1);
            }
          });
        }
      }
    },
    pushFilter(item, checked) {
      if (checked) {
        if (item.value == "all") {
          this.selectedArray = [];
          this.filter.status = {
            all: true,
            active: true,
            inactive: true,
            invited: true,
            join: true,
          };
          this.selectedArray.push({ text: "All", value: "all" });
        } else {
          this.selectedArray.push(item);
        }
      } else {
        if (item.value == "all" || this.filter.status.all) {
          this.filter.status = {
            all: false,
            active: false,
            inactive: false,
            invited: false,
            join: false,
          };
          this.selectedArray = [];
        } else {
          this.selectedArray.forEach((el, index) => {
            if (el.value == item.value) {
              this.selectedArray.splice(index, 1);
            }
          });
        }
      }
    },
    pushTypeFilter(item, checked) {
      if (checked) {
        
          this.selectedArray.push(item);
      } else {
       
          this.selectedArray.forEach((el, index) => {
            if (el.value == item.value) {
              this.selectedArray.splice(index, 1);
            }
          });
        }
    },
    pushtoLocationFilter(item, checked) {
      if (checked) {
        if (item.value == "allLocations") {
          this.selectedLocationArray = [];

          Object.keys(this.filter.location).forEach(key => {
            this.filter.location[key]=true;
          });
          this.selectedLocationArray.push({ text: "All", value: "allLocations" });

        } else {
          this.selectedLocationArray.push(item);
        }
      } else {
        if (item.value == "allLocations" || this.filter.location['all']) {
          Object.keys(this.filter.location).forEach(key => {
            this.filter.location[key]=false;
          });
          this.selectedLocationArray = [];
        } else {
          this.selectedLocationArray.forEach((el, index) => {
            if (el.value == item.value) {
              this.selectedLocationArray.splice(index, 1);
            }
          });
        }
      }
    },
    pushtoSpecialtyFilter(item, checked) {
      if (checked) {
        if (item.value == "allSpecialties") {
          this.selectedSpecialtyArray = [];

          Object.keys(this.filter.specialty).forEach(key => {
            this.filter.specialty[key]=true;
          });
          this.selectedSpecialtyArray.push({ text: "All", value: "allSpecialties" });

        } else {
          this.selectedSpecialtyArray.push(item);
          // console.log('selectedSpecialtyArray',this.selectedSpecialtyArray)
        }
      } else {
        if (item.value == "allSpecialties" || this.filter.specialty['all']) {
          Object.keys(this.filter.specialty).forEach(key => {
            this.filter.specialty[key]=false;
          });
          this.selectedSpecialtyArray = [];
        } else {
          this.selectedSpecialtyArray.forEach((el, index) => {
            if (el.value == item.value) {
              this.selectedSpecialtyArray.splice(index, 1);
            }
          });
        }
      }
    },
    searchStatus() {
      for (let key in this.showStatus) {
        if (key?.toLowerCase().includes(this.status?.toLowerCase())) {
          this.showStatus[key] = true;
        } else {
          this.showStatus[key] = false;
        }
      }
    },
    searchType() {
      for (let key in this.showType) {
        if (key?.toLowerCase().includes(this.type?.toLowerCase())) {
          this.showType[key] = true;
        } else {
          this.showType[key] = false;
        }
      }
    },
    searchLocation() {
      for (let key in this.showLocation) {
        if (key?.toLowerCase().includes(this.location?.toLowerCase())) {
          this.showLocation[key] = true;
        } else {
          this.showLocation[key] = false;
        }
      }
    },
    searchSpecialty() {
      for (let key in this.showSpecialties) {
        if (key?.toLowerCase().includes(this.specialty?.toLowerCase())) {
          this.showSpecialties[key] = true;
        } else {
          this.showSpecialties[key] = false;
        }
      }
    },
    clearAll() {
      this.filter.status = {
        all: false,
        active: false,
        inactive: false,
        invited: false,
        join: false,
      };
      this.filter.type = {
        md: true,
        do: true,
        arnp: true,
        pa: true,
      };

      this.selectedArray = [];
      this.selectedTypeArray = [];
      this.getAllUsers("all");
    },
    // filterUsers() {
    //   if (!this.filter.status && !this.filter.type) {
    //     this.getAllUsers("all");
    //   } else {
    //     this.getAllUsers(this.filter.status);
    //   }
    //   this.filterUse = true;
    //   this.drawer = false;
    // },
  getAllUsers(type) {
      let params = "";
      if (this.getLocationId) {
        params = `?location=${this.getLocationId}`;
      }
      api()
          .get(`/dpcproviders/providers` + params)
          .catch((err) => {
            if (err) {
              this.providers = [];

              this.noDataForThisLocationMessage = err.response.data;
            }
          })
          .then((res) => {
            if (res) {
              this.providers = res.data;
              this.allProviders = res.data;
              this.filterArray = this.providers;

              if (res.data.length < 1) {
                this.noResultMessage = true;
              } else {
                this.noResultMessage = false;
              }

              this.statusArray = this.userStatus;
              this.typeArray = this.userType;
              this.selectedArray = [];
              this.$store.commit("setNavItemFilter", false);
              this.$refs.success_modal.closePopUp();
            }
          });
    },
    removeFilter(item) {
      //remove filter for location
      if (item.value == "allLocations") {
        Object.keys(this.filter.location).forEach(key => {
            this.filter.location[key]=false;
          });
        this.selectedLocationArray = [];
       
      } else if (this.filter.location[item.value]) {
        this.filter.location[item.value] = false;
        this.selectedLocationArray.splice(this.selectedLocationArray.indexOf(item), 1);
      } 

      //remove filter for specialty
      if (item.value == "allSpecialties") {
        Object.keys(this.filter.specialty).forEach(key => {
            this.filter.specialty[key]=false;
          });
        this.selectedSpecialtyArray= [];
       
      } else if (this.filter.specialty[item.value]) {
        this.filter.specialty[item.value] = false;
        this.selectedSpecialtyArray.splice(this.selectedSpecialtyArray.indexOf(item), 1);
      } 
     
      //remove filter for type
      if (this.filter.type[item.value]) {
        this.filter.type[item.value] = false;
        this.selectedArray.splice(this.selectedArray.indexOf(item), 1);
      }
    },
    removeItem(item) {
      this.dialog = true;
      this.itemToRemove = item;
    },
    selectAllRows() {
      this.selectedRows = [];
      this.selectAll = !this.selectAll;
      this.allProviders.forEach((el) => {
        this.selectedRows.push(el._id);
      });
      if (!this.selectAll) {
        this.selectedRows = [];
      }
    },
    selectAllProviders() {
      this.selectAll = !this.selectAll;
    },

    removeSelected() {
      this.dialog = true;
    },
    closeSuccessModal() {
      this.$refs.success_modal.closePopUp();
      this.getAllProviders();
      this.overlay = false;
      this.showSaveButton = false;
    },
  
    activeRow(index, item) {
      this.index = index;
      this.itemById = document.getElementById("id" + index);
      this.itemById.classList.toggle("activeItem");

      if (this.itemById.classList.contains("activeItem")) {
        this.selectedRows.push(item._id);
      } else {
        let removeItem = this.selectedRows.find((x) => x === item._id);
        this.selectedRows.splice(this.selectedRows.indexOf(removeItem), 1);
      }
    },

    addProviders() {
      this.itemById.classList.remove("activeItem");
      let data = {
        search: "provider",
        ids: this.selectedRows,
      };
      let user = JSON.parse(localStorage.getItem("user"));
      let advisorId = user.groupPortal[0].organization.employerAdvisor;
      let employer = JSON.parse(localStorage.getItem("employer"));
      api()
        .post( `/advisors/${advisorId}/employers/${employer._id}/providers`, data)
        .catch((err) => {
                  if (err.response.status == 500) {
                    this.$refs.error_modal.openPopUp(
                      "There was an error, system admin is notified. Please try again later."
                    );}
                   else{
                    this.$refs.error_modal.openPopUp(err.response.data)
                   }
                  
                })
        .then((res) => {
          let text = "Providers added successfully to this Employer!";
          this.$refs.success_modal.openPopUp(text);
        });
    },
    // filterProviders() {
    //   let urlData = ``;
    //   urlData += this.filter.type
    //     ? `providerType=${this.filter.type.value}&`
    //     : "";
    //   urlData += this.filter.distance
    //     ? `distance=${this.filter.distance}&`
    //     : "";
    //   urlData += this.filter.rating
    //     ? `qualityRating=${this.filter.rating}&`
    //     : "";
    //   urlData += this.filter.status
    //     ? `status=${this.filter.status.value}&`
    //     : "";
    //   urlData += this.filter.preferredProvider
    //     ? `preferred=${this.filter.preferredProvider.value}&`
    //     : "";
    //   urlData += this.filter.manualOverride
    //     ? `manualOverride=${this.filter.manualOverride.value}&`
    //     : "";

    //   api()
    //     .get(`/advisors/providers/search?${urlData}`)
    //     .then((res) => {
    //       if (res) {
    //         if (res.data.providers.length < 1) {
    //           this.noDataMessage = "No Result Found. Try Again";
    //           this.allProviders = [];
    //           this.showSaveButton = false;
    //         } else {
    //           this.allProviders = res.data.providers;
    //           this.showSaveButton = true;
    //         }

    //         this.overlay = false;
    //       }
    //     });
    // },
    getAllProviders() {
      this.loader = true
      const self = this
      let params = ""
      if (this.getLocationId) {
        params = `?location=${this.getLocationId}`;
      }
      api()
        .get(`/dpcproviders/providers` + params)
        .then((res) => {
          if (res) {
            this.loader = false;
            this.filterItems = false;
            this.allProviders = res.data;
            this.filterArray = res.data;
            this.populateSpecialties();
            
            this.noDataForThisLocationMessage = "";
            if (this.getLocationId) {
              if (this.allProviders.length < 1) {
                this.noDataForThisLocationMessage =
                  "No providers connected with this location";
              }
            }
            this.$store.commit('setAllProviders', res.data)
          }
        })
        .finally(() => {
                this.loader = false
              });
    },
    searchProviders(val) {
      this.allProviders = this.filterArray.filter((el) => {

        return el.companyName?.toLowerCase().includes(val.toLowerCase()) ||
              el.providerName?.toLowerCase().includes(val.toLowerCase()) ||
              el["Provider First Name"]?.toLowerCase().includes(val.toLowerCase()) ||
              el["Provider Last Name (Legal Name)"]?.toLowerCase().includes(val.toLowerCase());
      });

      if (this.allProviders.length < 1) {
        this.filterItems = true;
      }
    },

    singleProvider(item) {
      //this.$store.commit("setSingleProviderInEmployerAdvisor", item);
      this.$router.replace("/dpc-providers/providers/provider/"+item.id);
    },
    removeListOfProvider() {
      let user = JSON.parse(localStorage.getItem("user"));
      let advisorId = user.groupPortal[0].organization.employerAdvisor;
      let employer = JSON.parse(localStorage.getItem("employer"));
      let array = [];
      let data = {
        ids: this.selectedRows,
      };

      api()
        .put(
          `/advisors/${advisorId}/employers/${employer._id}/providersDelete`,
          data
        )
        .then((res) => {
          if (res) {
            api()
              .get(`/advisors/${advisorId}/employers/${employer._id}/providers`)
              .then((res) => {
                if (res) {
                  this.allProviders = res.data.providers;
                  this.filterArray = res.data.providers;
                  this.dialog = false;
                  this.selectAll = false;
                }
              });
          }
        });
    },
    confirmRemove() {
      this.dialog = false;
      api()
        .delete(`/dpcproviders/providers/${this.itemToRemove._id}`)
        .then((res) => {
          if (res) {
            this.$refs.success_modal.openPopUp(res.data);
            this.getAllProviders();
          }
        });
    },
    closePopUp() {
      this.dialog = false;
    },
    openFilterMenu() {
      this.overlay = !this.overlay;
      this.$store.commit("showFilterMenu", this.overlay);
    },
    changeColor(status) {
      let myClass = "";
      if (status == "Matched") {
        myClass = "red--text";
      } else if (status == "Not matched") {
        myClass = "green--text";
      } else {
        myClass = "gray--text";
      }
      return myClass;
    },
    onResize() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth < 600) {
        this.display = false;
      } else {
        this.display = true;
      }
    },
    getLocations(){
      api()
        .get("/dpcproviders/locations")
        .then((res) => {
          this.locations = res.data;
          this.populateShowAndFilterLocation()

        });    
    },
    populateShowAndFilterLocation(){
      this.locations.forEach(element => {
      this.showLocation[element.name] = true;
      this.filter.location[element.name?.toLowerCase()] = false;
    });
  
    this.filter.location['all'] = false;
    this.showLocation['all'] = true;

    function getUnique(arr){
    let mapObj = new Map()
    
    arr.forEach(v => {
      let prevValue = mapObj.get(v.name)
      if(!prevValue){
        mapObj.set(v.name, v)
      } 
      })
      return [...mapObj.values()]
  }

    this.locations=getUnique(this.locations);
    },

    populateSpecialties(){
      this.allProviders.forEach(element => {
        this.specialties.push(element.specialty);

      this.showSpecialties[element.specialty] = true
      this.filter.specialty[element.specialty?.toLowerCase()] = false;
    });
    this.filter.specialty['all'] = false;
    this.showSpecialties['all'] = true;
    const unique = (value, index, self) => {
  return self.indexOf(value) === index
}
    this.specialties = this.specialties.filter(unique)

    }
  },
 
 
};
</script>
<style>
.noActiveItem {
  background-color: white !important;
}
</style>
